import { render, staticRenderFns } from "./WhoAmI.vue?vue&type=template&id=6794e4e4&scoped=true"
import script from "./WhoAmI.vue?vue&type=script&lang=js"
export * from "./WhoAmI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6794e4e4",
  null
  
)

export default component.exports